import { render, staticRenderFns } from "./CbdEditPageDynamic.vue?vue&type=template&id=c3634abc"
import script from "./CbdEditPageDynamic.vue?vue&type=script&lang=js"
export * from "./CbdEditPageDynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports